import { useTrack } from '../../utils/tracker';
import { Footer } from '../../ui';

export const FinishScreenFooter = () => {
  const trackVoter = useTrack();

  const registerPoweredByClick = () => {
    trackVoter({
      event: 'Clicked footer link',
    });
  };

  return (
    <Footer context="FinishScreen" onPoweredByClick={registerPoweredByClick} />
  );
};
